<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'NEW_VERSION_AVAILABLE' | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <span class="text-break">{{ 'NEW_VERSION_AVAILABLE_DESCRIPTION' | translate }}</span>
</div>

<div class="modal-footer">
  <div class="row w-100">
    <div class="col-12">
      <div class="d-flex justify-content-between w-100">
        <button class="btn btn-sm btn-outline-secondary btn-default" style="width: 10vw" (click)="close()">
          {{ 'CANCEL' | translate }}
        </button>
        <button
          class="btn btn-sm btn-primary btn-default"
          style="width: 10vw"
          (click)="reload()"
          [disabled]="isReloadButtonDisabled"
        >
          {{ 'RELOAD_PAGE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
